module.exports = __webpack_public_path__ + "static/media/tinyDisconnected.20b1fd29.svg";